export default __webpack_public_path__ + "static/media/search.1bee6af3.svg";